import React , { Component } from 'react';
import InputText from '../components/formulario/InputText';
import { CONSTANTES } from '../utils/Constantes';
import Select from '../components/formulario/Select';
import Boton from '../components/formulario/Boton';
import Utils from '../utils/Validate';
import CalendarioRango from '../components/formulario/CalendarioRango';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button';
import Popover from 'react-bootstrap/Popover';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from 'react-responsive-modal';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css';
import moment from 'moment';
import { Auth, Storage } from 'aws-amplify';
import ModalGenerico from '../components/comunes/ModalGenerico';
import Footer from '../components/comunes/Footer';
import Breadcrumb from '../components/comunes/Breadcrumb';

class EstadoUsuario extends Component {
    state = {
        
        isLoading       : false,
        m_modal         : '',
        casoModal: '',       
        filtered: [],
        open: false,
        disableDiv: false,
        idremesa: '',
        //Agregando Nuevo
        nombres: '',
        apellidos: '',
        codigoCorredor: '',
        correo: '',
        canal: '',
        subcanal: '',
		

        v_nombres: true,
        v_apellidos: true,
        v_codigoCorredor: true,
        v_perfil: true,    
        v_canal: true,
        v_subcanal: true,
        v_correo:true,
        d_codigoCorredor: false,
		
        //
        cantidadRemesas:0,      
        formValido: true,        
        
        lista_canal: [
           
        ],
        lista_sub_canal: [
           
        ]
    }

    disableDiv = () => {
        this.setState({
           disableDiv:true
        });
    }

    enableDiv = () => {
        this.setState({
           disableDiv:false
        });
    }

    previousPageHandler = () => {
        this.setLocalStorage("FLUJO","1");
        this.props.props.history.push({ pathname : CONSTANTES.RUTA.detalle });
    }

    onCloseModal = ()  => {
        this.setState({ open: false, listaDetalleTransacciones: [] });
    };

    setLocalStorage = (key, value) => {
        localStorage.setItem(key, JSON.stringify(value));
      }
    
      getLocalStorage = (key) => {
        if(localStorage.hasOwnProperty(key)){
          const local = localStorage.getItem(key);
          return JSON.parse(local);
        }else{
          return {};
        }
        
      }

    componentWillMount() {
    }

    async componentDidMount(){
		if("true" !== localStorage.getItem('login')){
            await Auth.signOut();
        }       
    }

    timer = () => {
        Auth.currentSession().then(response =>{
            var exp = moment.unix(response.accessToken.payload.exp).format('DD/MM/YYYY hh:mm:ss');
            var fecha_actual = moment(new Date()).format('DD/MM/YYYY hh:mm:ss');
            if(fecha_actual > exp){
                this.cerrarSesion();
            }
		})
		.catch(error =>{
			this.props.props.history.push({ pathname : CONSTANTES.RUTA.login }); 
		});
    }

    validarFormulario = (e) => {
        let response = true;
        
        
        return response;
    }
    validarCampo = (e) => {
        let { value , name } = e.target;
        this.setState({['v_' + name] : Utils.validarCampo(name, value)}, () => {
            console.log(this.state.v_nombres);
        })   
    }
    onChange = (e) => {
        let { name, value } = e.target;
        this.setState({ [name] : value }, () => {
        });        
    }    
    
    /** OBTENER REMESAS */
    estadoUsuarioService = (params, username) => {
        this.props.mostrarLoading();
        this.props.props.callServiceUsuarios("PUT","usuarios/" + username + ((this.props.usuario.enabled)?"/disable":"/enable"), {...params}).then(response => {
            // console.log(response);
            this.props.ocultarLoading();
            this.setState({open: false});
            if(response){
                console.log(response);
                if(200 === response.statusCode && 0 === response.body.responseCode){
                    //this.obtenerUsuario();
                    this.props.mostrarModal('mensaje', null, 'Se '+ (this.props.usuario.enabled?'inhabilitó':'habilitó') +' el usuario satisfactoriamente.');
                    this.props.irListarUsuario();
                    this.props.consultarAlVolver();
                }else{
                    this.props.mostrarModal("mensajeUsuario", null, response.body.responseMessage);
                }
                
            }
        }).catch( error => {
            console.error(error);
            this.props.ocultarLoading();
            this.props.mostrarModal("mensajeUsuario", null, "Hemos tenido problemas con nuestro sistema.");
        });
    }
    
    estadoUsuario = () => {
        let request = {            
            };      
        this.estadoUsuarioService(request, this.props.usuario.username);
    } 
    
    cerrarSesion = () => {
        this.props.mostrarLoading();      
        new Promise((resolve, reject) => {
          setTimeout(function(){
			//localStorage.clear();
			
            resolve(true);
          },500)
        }).then(() => {
          this.props.ocultarLoading();
          this.props.props.history.push({ pathname : CONSTANTES.RUTA.login });
        })
      }

    estado = () => {
        if(this.props.usuario.username)       
            this.setState({ open: true});
    }        

    render=()=>{
        const fontSize = 11;
        var { open,  page } = this.state;        
        ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableUserHeader', className:'tableUserCell'};
        //ReactTableDefaults.columnHeaderProps= {...ReactTableDefaults.columnHeaderProps, headerClassName: 'tableUserHeader2', className:'tableUserCell2'};
        
        return(
            <section className="showMntUsuarios container-fluid container-filtercolor">
                    <div className="container container-filter justify-content-start mb-flex-column">
                        <div className="container-filter-info justify-content-start mb-full">
                            <div className="">
                            <Breadcrumb  opciones={this.props.opciones} accionActual={this.props.accionActual} accionDefault={this.props.accionDefault} irDefault={this.props.irListarUsuario}/>
                                <h1><b>{!this.props.usuario.enabled?"Habilitar":"Inhabilitar"}</b> usuario</h1>
                                <p>Aquí gestiona la {!this.props.usuario.enabled?"habilitación":"inhabilitación"} del usuario en el Portal.</p>                                
                            </div>                            
                        </div>                       
                                                
                    </div>
                    <div className="container-fluid  d-flex mb-flex-column justify-content-between">
                        <div className={"container boxBuscar mb-w100 d-flex flex-justify-between w100"}>
                            <Col className="s12 m6 l6">
                                <div className="img-actualizarcontrasena"/>                                
                            </Col>
                            <Col className="seccionFiltrar s12 m6 l6">
                                <Row>
                                    <Col className="s12 m3 l2 font-footer" style={{float: "right" ,display: "flex", cursor: "pointer"}} onClick={this.props.irListarUsuario}>
                                        <div className="icon-regresar"/> Regresar
                                    </Col>
                                </Row>
                                <Row>
                                <Col  className="s12 m10 l7 div-actpass-det" style={{margin: "auto", float: "none"}}>    
                                    <Col  className="s12 m12 l12 div-subtitulo" style={{float: "left"}}>
                                        Datos del Usuario
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Nombre: {this.props.usuario.name && (this.props.usuario.name + " " + this.props.usuario.middle_name)}
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Username: {this.props.usuario.username}
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left", display: "flex"}}>
                                        Estado de cuenta: 
                                            <div className ={"div-estado "+(this.props.usuario.enabled?"activo":"inactivo")}>
                                                <div className ={"point-div-estado "+(this.props.usuario.enabled?"activo":"inactivo")}/>
                                                {this.props.usuario.enabled?"Activo":"Inactivo"}
                                            </div>
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Correo electrónico: {this.props.usuario.email}
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Última modificación: {moment(this.props.usuario.lastModifiedDate).format('MMM DD, YYYY')}
                                    </Col>
                                    <Col  className="s12 m12 l12" style={{float: "left"}}>
                                        Creado: {moment(this.props.usuario.createDate).format('MMM DD, YYYY')}
                                    </Col>
                                </Col>
                                <br/>
                                <Col className="s12 m6 l6" style={{margin: "auto", float: "none"}}>
                                    <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.estado} style={{marginBottom: "10px"}}>{this.props.usuario.enabled?"INHABILITAR":"HABILITAR"}</button>
                                </Col>
                                </Row>                              
                            </Col>
                        </div>
                        <Modal open={open} onClose={this.onCloseModal} center classNames={{modal: 'modal-sm'}} >                            
                            <div className="header-modal-usuario">
                                {this.props.usuario.enabled?"INHABILITACIÓN":"HABILITACIÓN"} DE USUARIO
                            </div>
                            <div className="body-modal-usuario">                                       
                            <Row  className="div-modal-det" style={{margin: "auto", float: "none"}}>    
                                <Col  className="s12 m12 l12 div-subtitulo-modal" style={{float: "left"}}>
                                ¿Estas seguro de {this.props.usuario.enabled?"inhabilitar":"habilitar"} el usuario?
                                </Col>
                                <Col  className="s12 m12 l12" style={{float: "left"}}>
                                    Nombre: {this.props.usuario.name && (this.props.usuario.name + " " + this.props.usuario.middle_name)}
                                </Col>
                                <Col  className="s12 m12 l12" style={{float: "left"}}>
                                    Username: {this.props.usuario.username}
                                </Col>                                   
                                <Col  className="s12 m12 l12" style={{float: "left"}}>
                                    Correo: {this.props.usuario.email}
                                </Col>
                                
                            </Row>
                            <Row>
                                <Col className="s12 m6 l4" style={{margin: "auto", float: "left"}}>
                                        <button className={"botonFormulario right btn-small btn-g no-box-shadow"} onClick={this.onCloseModal}  style={{marginBottom: "10px"}}>CANCELAR</button>
                                </Col>
                                <Col className="s12 m6 l4" style={{margin: "auto", float: "right"}}>
                                        <button className={"botonFormulario right btn-small no-box-shadow"} onClick={this.estadoUsuario} Style={{marginBottom: "10px"}}>CONFIRMAR</button>
                                </Col>
                            </Row>
                            </div>
                        </Modal>                                    
                    </div>   
            </section>                          
           
        );
    }
}
export default EstadoUsuario;
//export default HOC(ActualizarContrasena);